export function throttle(fn, wait){
  let throttled = false
  return function(...args){
    if (!throttled) {
      throttled = true
      fn.apply(this,args)
      setTimeout(() => {
        throttled = false
      }, wait)
    }
  }
}